var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealTimeOverSight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9043 59.0868C49.4077 71.918 60.0756 71.1368 69.9919 59.0798C59.2939 46.4173 49.0728 46.831 38.9043 59.0868ZM54.4455 62.2406C56.1909 62.2406 57.6059 60.8257 57.6059 59.0803C57.6059 57.3348 56.1909 55.9199 54.4455 55.9199C52.7001 55.9199 51.2852 57.3348 51.2852 59.0803C51.2852 60.8257 52.7001 62.2406 54.4455 62.2406Z",
    fill: "#F30002"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5918 17.8418V35.9931H51.257",
    stroke: "#161614",
    strokeWidth: 3.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6115 60.3287C31.0409 60.3299 29.4635 60.1897 27.8981 59.9043C21.3707 58.7144 15.5391 55.0893 11.5834 49.7626C7.62769 44.436 5.84323 37.8055 6.59114 31.213C7.33905 24.6205 10.5635 18.5583 15.6119 14.2531C20.6604 9.94789 27.1558 7.72122 33.7839 8.02367C40.4119 8.32612 46.6776 11.1351 51.3129 15.8822C55.9483 20.6293 58.6071 26.96 58.7515 33.5932C58.8029 35.9552 58.5341 38.2927 57.9669 40.5469H62.5184C63.0089 38.2478 63.2364 35.8829 63.1845 33.4968C63.0157 25.7395 59.9062 18.3361 54.4854 12.7845C49.0646 7.23302 41.7372 3.94804 33.986 3.59434C26.2348 3.24063 18.6387 5.84462 12.7347 10.8794C6.83081 15.9141 3.06 23.0036 2.18535 30.7132C1.31071 38.4229 3.39755 46.1769 8.0236 52.4062C12.6496 58.6354 19.4694 62.8748 27.1028 64.2664C28.9324 64.5999 30.7759 64.7639 32.6115 64.7626V60.3287Z",
    fill: "#161614"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealTimeOverSight);
export default __webpack_public_path__ + "static/media/Real-Time-Over-Sight.ee966c43166aefead1f7fa7bbf1438fc.svg";
export { ForwardRef as ReactComponent };